module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /Users/frontend-dev/Desktop/ESM/elit_stroy_front/~/babel-runtime/~/core-js/library/modules/$.html.js
// module id = 153
// module chunks = 0